import { render, staticRenderFns } from "./CustomGTable.vue?vue&type=template&id=34385348"
import script from "./CustomGTable.vue?vue&type=script&lang=js"
export * from "./CustomGTable.vue?vue&type=script&lang=js"
import style0 from "./CustomGTable.vue?vue&type=style&index=0&id=34385348&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports